module.exports = __webpack_public_path__ + "img/meditation_500.af8b908e.svg";